import services from 'services/services';
import * as types from '../types';

// Import helpers
import { checkFetchErrors } from '../helpers_actions/convert_helpers';

// ******************** FETCH SECTIONS - TABLE DATA ********************
export const fetchSectionsAssigned = (itemId) => async (dispatch) => {
	try {
		// Dispatch a loading action
		dispatch({
			type: types.FETCH_SECTIONS_ASSIGNED_LOADING,
			payload: true
		});

		const { data } = await services.get(`/section/group/${itemId}/sections`);

		// Dispatch an action with data
		dispatch({
			type: types.FETCH_SECTIONS_ASSIGNED_SUCCESS,
			payload: data
		});
	} catch (error) {
		dispatch({
			type: types.FETCH_SECTIONS_ASSIGNED_ERROR,
			payload: checkFetchErrors(error)
		});
	}
};
